import React from "react";
import classNames from "classnames";
import Image from "../../elements/Image";

const Logo = ({ className, ...props }) => {
  const classes = classNames("brand", className);

  return (
    <div {...props} className={classes}>
      <h1 className="m-0">
          <Image
            className="logo-img"
            src={require("./../../../assets/logo.png")}
            alt="REAP"
            width={185}
            height={185}
            onClick={
              ()=>{
                window.location.replace("/");
              }
            }
          />
      </h1>
    </div>
  );
};

export default Logo;
